import { merge } from 'lodash'
import * as components from './components'
import { lightPalette } from './palette'
import { organizations } from './modules/organizations'

export const lightTheme = merge(
  { components },
  {
    palette: {
      ...lightPalette,
      organizations,
    },
  },
  { mode: 'light' },
)
